import React from 'react';
import { StyleSheet, View } from 'react-native';
import { AppText } from '../AppText';
import Colors from '../../constants/Colors';

const styles = StyleSheet.create({
  tile: {
    width: 44,
    height: 44,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  confirmed: {
    backgroundColor: Colors.siteListPaleGreenBg,
    borderWidth: 1,
    borderColor: Colors.siteListPaleGreenBorder,
  },
  neutral: {
    backgroundColor: Colors.lightGrayBackground,
    borderWidth: 1,
    borderColor: Colors.grayBorder,
  },
  initials: {
    fontSize: 17,
    fontWeight: '700',
  },
  confirmedText: { color: Colors.darkGreen },
  neutralText: { color: Colors.grayInfoText },
});

// name is required per the Site type, but this is still-stabilizing API data -- guard against a
// missing name rather than throwing, which would otherwise blank the whole card (SiteList's
// per-item ErrorBoundary swallows render errors silently).
function initialsFromName(name: string | undefined): string {
  const words = (name ?? '').trim().split(/\s+/).filter(Boolean);
  const first = words[0]?.[0] ?? '';
  const second = words[1]?.[0] ?? '';
  return `${first}${second}`.toUpperCase();
}

export interface SiteAvatarProps {
  name: string | undefined;
  neutral?: boolean;
}

export function SiteAvatar({ name, neutral = false }: SiteAvatarProps) {
  return (
    <View style={[styles.tile, neutral ? styles.neutral : styles.confirmed]} testID="site-avatar">
      <AppText style={[styles.initials, neutral ? styles.neutralText : styles.confirmedText]}>
        {initialsFromName(name)}
      </AppText>
    </View>
  );
}
